import { useState, useRef, useCallback } from "react";

export const useConfirmModal = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("Confirmation");
  const resolverRef = useRef(null);

  const askConfirmation = useCallback((msg, modalTitle = "Confirmation") => {
    return new Promise((resolve) => {
      setMessage(msg);
      setTitle(modalTitle);
      resolverRef.current = resolve;
      setShow(true);
    });
  }, []);

  const handleDecision = useCallback((confirmed) => {
    setShow(false);
    if (resolverRef.current) {
      resolverRef.current(confirmed);
      resolverRef.current = null;
    }
  }, []);

  return {
    show,
    title,
    message,
    askConfirmation,
    onConfirm: () => handleDecision(true),
    onClose: () => handleDecision(false),
  };
};
